 angular
     .module('vppApp')
     .factory('ProfileSecurityService', function() {

         var ProfileSecurityService = {

             "password": "",
             "securityQuestion": "",
             "securityAnswer": ""

         };

         return ProfileSecurityService;

     });
